import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormsModule, ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {NbButtonModule, NbFormFieldModule, NbInputModule, NbPopoverModule} from '@nebular/theme';
import {TuiDayRange} from '@taiga-ui/cdk';
import {TuiCalendarRange, TuiInputDateRange} from "@taiga-ui/kit";
import { TuiTextfieldComponent, TuiTextfieldOptionsDirective, TuiInput } from '@taiga-ui/core'
import {takeUntil, tap} from 'rxjs/operators'
import {BaseFieldType} from '../../base-field-type'

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker-component.html',
  imports: [
    NbFormFieldModule,
    TuiCalendarRange,
    NbInputModule,
    NbPopoverModule,
    NbButtonModule,
    ReactiveFormsModule,
    FormsModule, TuiInputDateRange, TuiInput,
    TuiTextfieldComponent,
    TuiTextfieldOptionsDirective
  ],
  styles: `:host {
    min-width: 190px
  }`
})
export class DatepickerComponent extends BaseFieldType implements OnInit {
  control = new UntypedFormControl();

  @Input() value: TuiDayRange;
  @Output() rangeSelect: EventEmitter<TuiDayRange> = new EventEmitter<TuiDayRange>();
  @Output() onClear: EventEmitter<void> = new EventEmitter();

  ngOnInit() {
    if (this.value) {
      this.control.patchValue(this.value);
    }

    this.control
      .valueChanges
      .pipe(
        takeUntil(this.unsubscribe),
        tap(_ => {
          if (_ === null) {
            this.onClear.emit();
          }
        })
      ).subscribe();
  }

  dateFilter(dayRange: TuiDayRange) {
    // Контрол разделяют tuiInputDateRange (инпут) и tui-calendar-range — он ДОЛЖЕН
    // держать TuiDayRange, а не строку. Раньше сюда патчилась форматированная строка
    // (артефакт миграции Taiga 4→5): из-за неё календарь получал не-массив, и его
    // getItemRange падал `value.find is not a function` при завершении диапазона.
    this.control.patchValue(dayRange);

    this.rangeSelect.emit(dayRange);
  }

  clear(): void {
    this.control.patchValue(null);
  }
}
